var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfUpf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3170_64743)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3170_64743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "url(#paint0_linear_3170_64743)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "#2C87BB",
    fillOpacity: 0.88
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 3.44434H9.75C9.3375 3.44434 9 3.58898 9 3.76576V7.62291C9 7.79969 9.3375 7.94434 9.75 7.94434H20.25C20.6625 7.94434 21 7.79969 21 7.62291V3.76576C21 3.58898 20.6625 3.44434 20.25 3.44434ZM15.375 5.69434H19.125C19.335 5.69434 19.5 5.52934 19.5 5.31934C19.5 5.10934 19.335 4.94434 19.125 4.94434H15.375C15.165 4.94434 15 5.10934 15 5.31934C15 5.52934 15.165 5.69434 15.375 5.69434ZM10.5 5.19434C10.5 4.91819 10.7239 4.69434 11 4.69434H11.5C11.7761 4.69434 12 4.91819 12 5.19434C12 5.47048 11.7761 5.69434 11.5 5.69434H11C10.7239 5.69434 10.5 5.47048 10.5 5.19434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 7.94434L14.625 13.9443C14.625 14.3643 14.79 14.6943 15 14.6943C15.21 14.6943 15.375 14.3643 15.375 13.9443L15.375 7.94434C15.375 7.52434 15.21 7.19434 15 7.19434C14.79 7.19434 14.625 7.52434 14.625 7.94434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 13.1943H12.375C12.1687 13.1943 12 13.2667 12 13.3551V15.2836C12 15.372 12.1687 15.4443 12.375 15.4443H17.625C17.8313 15.4443 18 15.372 18 15.2836V13.3551C18 13.2667 17.8313 13.1943 17.625 13.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 14.1943,
    x2: 20.5,
    y2: 14.1943,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3125 10.1943H13.6875C13.5844 10.1943 13.5 10.3149 13.5 10.4622V13.6765C13.5 13.8238 13.5844 13.9443 13.6875 13.9443H16.3125C16.4156 13.9443 16.5 13.8238 16.5 13.6765V10.4622C16.5 10.3149 16.4156 10.1943 16.3125 10.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9771 18.624L10.9824 23.8555C10.9824 24.2601 10.9198 24.6289 10.7944 24.9619C10.6727 25.2913 10.499 25.5742 10.2734 25.8105C10.0443 26.0469 9.76855 26.2295 9.44629 26.3584C9.1276 26.4873 8.76953 26.5518 8.37207 26.5518C7.98177 26.5518 7.62907 26.4891 7.31396 26.3638C6.99886 26.2349 6.73031 26.0522 6.5083 25.8159C6.28271 25.5796 6.10726 25.2949 5.98193 24.9619C5.86019 24.6289 5.79753 24.2601 5.79395 23.8555L5.80469 18.624H7.07764L7.08838 23.8555C7.09196 24.1025 7.1224 24.3299 7.17969 24.5376C7.23698 24.7417 7.32113 24.9154 7.43213 25.0586C7.53955 25.1947 7.67025 25.3021 7.82422 25.3809C7.98177 25.4561 8.16439 25.4937 8.37207 25.4937C8.58333 25.4937 8.76953 25.4561 8.93066 25.3809C9.09538 25.3021 9.23324 25.1911 9.34424 25.0479C9.45524 24.901 9.53939 24.7274 9.59668 24.5269C9.65397 24.3228 9.6862 24.099 9.69336 23.8555L9.7041 18.624H10.9771ZM13.8828 23.4634V26.4443H12.5938V18.624H15.2095C15.6034 18.6276 15.965 18.6867 16.2944 18.8013C16.6274 18.9159 16.9139 19.0788 17.1538 19.29C17.3937 19.5013 17.5799 19.7573 17.7124 20.0581C17.8449 20.3589 17.9111 20.6973 17.9111 21.0732C17.9111 21.4349 17.8449 21.7625 17.7124 22.0562C17.5799 22.3462 17.3937 22.5951 17.1538 22.8027C16.9139 23.014 16.6274 23.1769 16.2944 23.2915C15.965 23.4061 15.6034 23.4634 15.2095 23.4634H13.8828ZM13.8828 22.4106H15.2095C15.4279 22.4071 15.623 22.373 15.7949 22.3086C15.9704 22.2406 16.119 22.1475 16.2407 22.0293C16.3625 21.9111 16.4538 21.7715 16.5146 21.6104C16.5791 21.4492 16.6113 21.2738 16.6113 21.084C16.6113 20.8763 16.5791 20.6883 16.5146 20.52C16.4538 20.3481 16.3625 20.1995 16.2407 20.0742C16.119 19.9489 15.9704 19.8522 15.7949 19.7842C15.623 19.7161 15.4279 19.6803 15.2095 19.6768H13.8828V22.4106ZM23.8086 23.1143H20.5V26.4443H19.2002V18.624H24.2812V19.6929H20.5V22.0508H23.8086V23.1143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3170_64743",
    x: 0,
    y: -1,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3170_64743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3170_64743",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3170_64743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfUpf);
export default __webpack_public_path__ + "static/media/AF-UPF.6f6eef651c9fedac47e31964e1e19218.svg";
export { ForwardRef as ReactComponent };